import Spin from 'antd/lib/spin';
import { useSiteMapStore } from './useSiteMapStore';

export const MapLoading = () => {
    const isMarkersLoading = useSiteMapStore(state => state.isMarkersLoading);

    if (isMarkersLoading) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    fontSize: 12,
                    color: '#888787',
                    pointerEvents: 'none',
                }}
            >
                <Spin size="small" /> loading...
            </div>
        );
    }

    return null;
};
